import MESSAGES from './ar';

export default {
  ...MESSAGES,
  'Número de Patente:': 'Número de placa o chasis si es concesionario:',
  'Debe ingresar la patente': 'Debes ingresar el número de placa o chasis',
  'Número de patente *': 'Número de placa o chasis si es concesionario*',
  'Por favor ingrese el número de patente':
    'Por favor ingrese el número de placa o chasis',
  'Este es el total de M2 de láminas registradas durante este mes':
    'Este es el total de M2 de películas registradas durante este mes',
  'Láminas de proyectos pendientes': 'Películas de proyectos pendientes',
  'Lámina de seguridad': 'Película de seguridad',
  'Lámina de control solar': 'Película de control solar',
  'Lámina de seguridad:': 'Película de seguridad:',
  'Lámina de seguridad: *': 'Película de seguridad: *',
  'Eliminar esta lámina': 'Eliminar esta película',
  'Agregar nueva lámina': 'Agregar nueva película',
  'Lámina de control solar: *': 'Película de control solar: *',
  Láminas: 'Películas',
  'Debe agregar una lámina': 'Debes agregar una película',
  'Debe seleccionar una lámina': 'Debes seleccionar una película',
  'Lámina de control solar:': 'Película de control solar:',
  'Lámina de seguridad *': 'Película de seguridad *',
  'Por favor seleccione una lámina de seguridad':
    'Por favor selecciona una película de seguridad',
  'Lámina de control solar *': 'Película de control solar *',
  'Por favor seleccione una lámina de control solar':
    'Por favor selecciona una película de control solar',
  'Láminas:': 'Películas:',
  'Lámina colocada': 'Película colocada',
  'Lámina *': 'Película *',
  'Por favor seleccione la lámina de seguridad colocada':
    'Por favor selecciona la película de seguridad colocada',
  'Por favor ingresa el número de RUN de la lámina colocada':
    'Por favor ingresa el número de Lote de la película colocada',
  'Ranking de láminas utilizadas': 'Ranking de películas utilizadas',
  'CUIT:': 'NIT:',
  'CUIT: *': 'NIT: *',
  'Debe ingresar un CUIT': 'Debes ingresar un NIT',
  Provincia: 'Región',
  'Debe seleccionar una provincia': 'Debes seleccionar una región',
  'Provincia *': 'Región *',
  'Provincia:': 'Región:',
  'Provincia: *': 'Región: *',
  'Vidrio doble - DVH': 'Doble acristalamiento',
  Dominio: 'Placa',
  'Dominio:': 'Placa o chasis si es concesionario:',
  'Número de Patente:': 'Número de placa o chasis si es concesionario:',
  'Debe ingresar la patente': 'Debes ingresar el número de placa o de chasis',
  'Número de patente *': 'Número de placa o chasis si es concesionario *',
  'Por favor ingrese el número de patente':
    'Por favor ingresa el número de placa o de chasis',
};
